var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeUnVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L21 21",
    stroke: "#848A9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.584 10.587C9.80248 11.3679 9.80203 12.6345 10.583 13.416C11.3639 14.1975 12.6305 14.1979 13.412 13.417",
    stroke: "#848A9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19798 4.78814C8.87939 4.87928 8.695 5.21143 8.78614 5.53002C8.87728 5.84861 9.20943 6.033 9.52802 5.94186L9.19798 4.78814ZM12 5L11.9979 5.6H12V5ZM22 12L22.5209 12.2978C22.6264 12.1133 22.6264 11.8868 22.5209 11.7023L22 12ZM19.0564 15.0807C18.8315 15.3241 18.8464 15.7037 19.0897 15.9286C19.3331 16.1535 19.7127 16.1386 19.9376 15.8953L19.0564 15.0807ZM17.6925 17.8464C17.9672 17.6612 18.0397 17.2882 17.8544 17.0135C17.6692 16.7388 17.2962 16.6663 17.0215 16.8516L17.6925 17.8464ZM2 12L1.47909 11.7022C1.37365 11.8867 1.37363 12.1132 1.47906 12.2977L2 12ZM6.96881 7.15555C7.24304 6.96954 7.31456 6.59643 7.12855 6.32219C6.94253 6.04796 6.56943 5.97644 6.29519 6.16245L6.96881 7.15555ZM9.52802 5.94186C10.3311 5.71213 11.1626 5.59704 11.9979 5.6L12.0021 4.40001C11.0538 4.39665 10.1097 4.52732 9.19798 4.78814L9.52802 5.94186ZM12 5.6C15.712 5.6 18.8771 7.74455 21.4791 12.2977L22.5209 11.7023C19.7889 6.92146 16.288 4.4 12 4.4V5.6ZM21.4791 11.7022C20.7193 13.0314 19.9112 14.1559 19.0564 15.0807L19.9376 15.8953C20.8648 14.8921 21.7247 13.6906 22.5209 12.2978L21.4791 11.7022ZM17.0215 16.8516C15.4879 17.8859 13.8204 18.4 12 18.4V19.6C14.0636 19.6 15.9641 19.0121 17.6925 17.8464L17.0215 16.8516ZM12 18.4C8.28801 18.4 5.12288 16.2555 2.52094 11.7023L1.47906 12.2977C4.21112 17.0785 7.71199 19.6 12 19.6V18.4ZM2.52091 12.2978C3.85871 9.95733 5.34611 8.25623 6.96881 7.15555L6.29519 6.16245C4.47989 7.39378 2.87929 9.25267 1.47909 11.7022L2.52091 12.2978Z",
    fill: "#848A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeUnVisible);
export default __webpack_public_path__ + "static/media/EyeUnVisible.db67083e5354d438b839dce817e09294.svg";
export { ForwardRef as ReactComponent };